import type { ReactNode } from "react";
import { Link } from "react-router-dom";

import type { Role } from "../lib/api";
import { useSession } from "../lib/session";
import { Card } from "./Card";

export interface RoleGuardProps {
  allow: Role;
  children: ReactNode;
}

/** Renders a clear Indonesian notice instead of a blank screen on role mismatch. */
export function RoleGuard({ allow, children }: RoleGuardProps) {
  const me = useSession();

  if (!me) {
    return null;
  }

  if (me.role === allow) {
    return <>{children}</>;
  }

  const isLeaderBlockedFromAdmin = me.role === "leader" && allow === "admin";

  return (
    <Card className="mx-auto mt-8 max-w-xl text-center">
      <p className="text-4xl" aria-hidden="true">
        🔒
      </p>
      <h2 className="mt-4 text-lg font-bold text-text">Halaman ini tidak untuk Anda</h2>
      <p className="mt-2 text-sm text-muted">
        {isLeaderBlockedFromAdmin
          ? "Halaman ini hanya dapat diakses oleh admin. Sebagai leader, Anda hanya dapat mengirim laporan melalui formulir input."
          : "Halaman ini hanya dapat diakses oleh leader. Sebagai admin, Anda dapat melihat laporan dan menelusuri data."}
      </p>
      <Link
        to={isLeaderBlockedFromAdmin ? "/input" : "/admin/laporan"}
        className="mt-6 inline-flex items-center justify-center rounded-control accent-gradient px-5 py-3 text-sm font-semibold text-white shadow-clay transition-all active:clay-pressed"
      >
        {isLeaderBlockedFromAdmin ? "Ke formulir input" : "Ke halaman laporan"}
      </Link>
    </Card>
  );
}
